export enum AgencyPlan {
  FREE = 'free',
  TRIAL = 'trial',
  ONE_MONTH_TRIAL = 'one_month_trial',
  STARTER = 'starter',
  PREMIUM = 'premium'
}

export const getAgencyPlanLabel = (plan: AgencyPlan): string => {
  switch (plan) {
    case AgencyPlan.FREE:
      return 'Free';
    case AgencyPlan.TRIAL:
      return 'Trial';
    case AgencyPlan.ONE_MONTH_TRIAL:
      return 'One Month Trial';
    case AgencyPlan.STARTER:
      return 'Starter';
    case AgencyPlan.PREMIUM:
      return 'Premium';
    default:
      return 'Unknown';
  }
};

export const getAgencyPlanColor = (plan: AgencyPlan): string => {
  switch (plan) {
    case AgencyPlan.FREE:
      return 'neutrals.500';
    case AgencyPlan.TRIAL:
      return 'warning.500';
    case AgencyPlan.ONE_MONTH_TRIAL:
      return 'warning.500';
    case AgencyPlan.STARTER:
      return 'success.700';
    case AgencyPlan.PREMIUM:
      return 'primary.900';
    default:
      return 'neutrals.500';
  }
};

export const getAgencyPlanOptions = (): {
  value: AgencyPlan;
  label: string;
}[] => {
  return Object.values(AgencyPlan).map((plan) => ({
    value: plan,
    label: getAgencyPlanLabel(plan)
  }));
};
